import React from 'react';
import styled from 'styled-components';

import { Plane } from '@lt/components/icons-react/userflow';
import { FilterOutlined } from '@lt/components/icons-react';
import {
  Path65 as Path65Desktop,
  Path66 as Path66Desktop,
} from '@lt/components/icons-react/userflow/emptyFiltrationBlock/desktop';
import {
  Path65 as Path65Mobile,
  Path66 as Path66Mobile,
} from '@lt/components/icons-react/userflow/emptyFiltrationBlock/mobile';

/**
 * Блок отображается, если под фильтры не попал ни один оффер
 */
export const EmptyBlock = ({ children, isMobile = false }) => (
  <Container>
    <Decorate isMobile={isMobile}>
      <Circle>
        <FilterIcon />
      </Circle>

      <StyledAirplanes isMobile={isMobile}>
        <FirstPlaneIcon $isMobile={isMobile} />
        <SecondPlaneIcon $isMobile={isMobile} />

        {isMobile ? <Path66MobileIcon /> : <Path66DesktopIcon />}
        {isMobile ? <Path65MobileIcon /> : <Path65DesktopIcon />}
      </StyledAirplanes>
    </Decorate>

    <Block>{children}</Block>
  </Container>
);

const Container = styled.div`
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 16px 8px;
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Decorate = styled(Block)<{ isMobile: boolean }>`
  height: ${({ isMobile }) => (isMobile ? 139 : 153)}px;
`;

const StyledAirplanes = styled.div<{ isMobile: boolean }>`
  position: absolute;
  width: ${({ isMobile }) => (isMobile ? 284 : 600)}px;
  height: 100%;
`;

const Circle = styled.div`
  border-radius: 50%;
  background: #e6e9ee;
  width: 57px;
  height: 57px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 6px;
`;

const FilterIcon = styled(FilterOutlined)`
  width: 32px;
  height: 34px;
`;

const PlaneIcon = styled(Plane)`
  position: absolute;
  width: 30px;
`;

const SecondPlaneIcon = styled(PlaneIcon)<{ $isMobile: boolean }>`
  right: ${({ $isMobile }) => ($isMobile ? 20 : 115)}px;
  bottom: ${({ $isMobile }) => ($isMobile ? 13 : 10)}px;
  transform: rotate(15deg);
`;

const FirstPlaneIcon = styled(PlaneIcon)<{ $isMobile: boolean }>`
  top: -30px;
  right: ${({ $isMobile }) => ($isMobile ? 10 : 212)}px;
  transform: rotate(1deg);
`;

const Path66DesktopIcon = styled(Path66Desktop)`
  position: absolute;
  top: -4px;
  right: 224px;
  top: 79px;
  right: 153px;
`;

const Path65DesktopIcon = styled(Path65Desktop)`
  position: absolute;
  bottom: 89px;
  right: 247px;
`;

const Path66MobileIcon = styled(Path66Mobile)`
  width: 232px;
  position: absolute;
  top: 35px;
  left: -5px;
`;

const Path65MobileIcon = styled(Path65Mobile)`
  width: 249px;
  position: absolute;
  left: 0;
  top: -5px;
`;
